import NewFeatureTooltip from './NewFeatureTooltip';

export default NewFeatureTooltip;
